module.exports = __webpack_public_path__ + "static/media/freezing_weather.43fc2b59.jpg";